import { render, staticRenderFns } from "./clubs.vue?vue&type=template&id=1b858d59&scoped=true&"
import script from "./clubs.vue?vue&type=script&lang=js&"
export * from "./clubs.vue?vue&type=script&lang=js&"
import style0 from "./clubs.vue?vue&type=style&index=0&id=1b858d59&lang=scss&scoped=true&"
import style1 from "./clubs.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./clubs.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b858d59",
  null
  
)

export default component.exports